import { Inbox, X } from "lucide-react";

/**
 * Full-width modal viewer for report data tables.
 */
export default function ReportViewModal({ title, columns, rows, onClose, headerExtra, modalId = "rpt-modal-title" }) {
  return (
    <div className="rpt-modal-backdrop" role="dialog" aria-modal="true" aria-labelledby={modalId}>
      <div className="rpt-modal">
        <div className="rpt-modal__head">
          <div className="rpt-modal__head-main">
            <h2 id={modalId} className="rpt-modal__title">
              {title}
            </h2>
            {headerExtra}
          </div>
          <button type="button" className="rpt-modal__close" onClick={onClose} aria-label="Close">
            <X size={18} strokeWidth={2.25} />
          </button>
        </div>
        <div className="rpt-modal__body">
          {!rows.length ? (
            <div className="rpt-empty-state">
              <div className="rpt-empty-state__icon" aria-hidden="true">
                <Inbox size={22} strokeWidth={1.75} />
              </div>
              <p className="rpt-empty-state__title">No records found</p>
              <p className="rpt-empty-state__text">Adjust your filters and try again.</p>
            </div>
          ) : (
            <div className="rpt-table-wrap">
              <table className="rpt-table">
                <thead>
                  <tr>
                    {columns.map((col) => (
                      <th key={col} scope="col">
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, idx) => (
                    <tr key={idx}>
                      {columns.map((col) => (
                        <td key={col}>{row[col] ?? "—"}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="rpt-modal__foot">
          {rows.length} record{rows.length === 1 ? "" : "s"}
        </div>
      </div>
    </div>
  );
}
